module.exports = __webpack_public_path__ + "img/sims-right.00e239e5.png";